<template>
  <div class="customer-panel">
    <div class="calc-cost-table-wrapper">
      <CalcCostTable :hideColumn="['客户', '材料', '配方', '金蝶云']" :tableLoading="calcCostTableLoading"/>
    </div>
    <Divider orientation="left">销量分析</Divider>
    <div class="flex">
      <div id="monthlyVolStatChart" style="width: 500px; height: 250px"></div>
      <div>
        <h2>最近60天订单</h2>
        <Table
          border
          :columns="recentVolCol"
          :data="sixtyDayOrders"
          height="250"
          width="500"
        >
        </Table>
      </div>
    </div>
    <Divider orientation="left">回款分析</Divider>

    <div class="flex">
      <div id="monthlyReceiveStatChart" style="width: 500px; height: 250px"></div>
      <div>
        <h2>最近1年收款记录</h2>
        <Table
          border
          :columns="receiveCol"
          :data="receiveList"
          height="250"
          width="600"
        >
        </Table>
      </div>
      
      
    </div>
    <div class="flex">
      <div v-for="ss in salesStat">
        <h2>{{ ss.company?.abbr }}账龄（截止{{ artableDate.year }}/{{ artableDate.month }}末）</h2>
        <Table
          :columns="arTableCol"
          :data="ss.arTable ?? []"
          border
        ></Table>
      </div>
    </div>
    
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapState } from "vuex";
import * as echarts from "echarts/core";
import { BarChart, PictorialBarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
} from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import { Divider } from "view-design";
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PictorialBarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
]);
import CalcCostTable from "@/views/CaclSalesCost/CalcCostTable.vue";
import { fromModelToText, typeToText, statusToText, billStatusToText, billTagsToText } from '@/utils/index'


export default {
  name: "CustomerAnalyzeDetailPanel",
  components: {
    Divider,
    CalcCostTable
},
  data() {
    return {
      calcCostTableLoading: false,
      monthlyVolStatChart: null,
      monthlyReceiveStatChart: null,
      unsubscribeVuexAction: null,
      recentVolCol: [
        {
          title: "日期（至今天数）",
          key: "planArrivedAt",
          width: 190,
          render: (h, params) => {
            const toNowDays = dayjs().diff(dayjs(params.row.planArrivedAt), "day");
            return h('div', dayjs(params.row.planArrivedAt).format('YYYY年M月D日' + `(${toNowDays}天)`))
          }
        },
        {
          title: "销售项目",
          key: "sales",
          width: 140,
          render: (h, params) => {
            return h('div', params.row.sales?.abbr)
          }
        },
        {
          title: "吨数",
          key: "volPlan",
          render: (h, params) => {
            return h('div', params.row.volPlan)
          }
        },
      ],
      receiveCol: [
        {
          title: "状态",
          key: "status",
          width: 80,
          render: (h, params) => {
            return h('div', statusToText[params.row.status])
          }
        },
        {
          title: "日期（至今天数）",
          key: "receivedAt",
          width: 190,
          render: (h, params) => {
            const toNowDays = dayjs().diff(dayjs(params.row.receivedAt), "day");
            return h('div', dayjs(params.row.receivedAt).format('YYYY年M月D日') + `(${toNowDays}天)`)
          }
        },
        {
          title: "收款公司",
          key: "company",
          width: 80,
          align: "left",
          render: (h, params) => h("span", params.row.company?.abbr)
        },
        {
          title: "类型",
          key: "type",
          width: 80,
          render: (h, params) => h("span", typeToText[params.row.type]),
        },
        {
          title: "金额",
          key: "amount",
          align: 'right',
          render: (h, params) => {
            return h('div', params.row.amount.toLocaleString("zh", {
              maximumFractionDigits: 0,
            }))
          }
        },
      ],
      arTableCol: [
        {
          title: "月份",
          key: "month",
          align: "left",
          width: 90,
          render: (h, params) => {
            return h("div", params.row.year + "/" + params.row.month);
          },
        },
        {
          title: "账龄",
          key: "estAging",
          align: "right",
          width: 80,
          render: (h, params) => {
            const date = dayjs(params.row.year + "/" + params.row.month);
            const calcDate = dayjs().diff(date, "month") + 1;
            return h(
              "div",
              calcDate
            );
          },
        },
        {
          title: "金额",
          key: "estAging",
          align: "right",
          width: 120,
          render: (h, params) => {
            return h(
              "div",
              params.row.accountsReceivable &&
                (params.row.accountsReceivable > 1 ||
                  params.row.accountsReceivable < -1)
                ? Number(params.row.accountsReceivable).toLocaleString("zh", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : ""
            );
          },
        },
      ]
    };
  },
  computed: {
    ...mapGetters({
      monthlyVolStatChartDataSource: "customerAnalyze/monthlyVolStatChartDataSource",
      monthlyReceiveStatChartDataSource: "customerAnalyze/monthlyReceiveStatChartDataSource",
    }),
    ...mapState({
      selectedCustomer: (state) => state.customerAnalyze.selectedCustomer,
      monthlyVolStat: (state) => state.customerAnalyze.monthlyVolStat,
      monthlyReceiveStat: (state) => state.customerAnalyze.monthlyReceiveStat,
      sixtyDayOrders: (state) => state.customerAnalyze.sixtyDayOrders,
      receiveList: (state) => state.customerAnalyze.receiveList,
      salesStat: (state) => state.customerAnalyze.salesStat,
      artableDate: (state) => state.customerAnalyze.artableDate,
    }),
  },
  methods: {
    ...mapActions({
      getSalesLatestCost: "caclSalesCost/getSalesLatestCostAction",
    }),
    drawChart() {
      this.monthlyVolStatChart = echarts.init(
        document.getElementById("monthlyVolStatChart")
      );

      this.monthlyReceiveStatChart = echarts.init(
        document.getElementById("monthlyReceiveStatChart")
      );
    },
    reloadChart() {
      const defaultChartOption = {
        grid: {
          bottom: 20
        },
        legend: {},
        tooltip: {},
        dataset: {
          source: this.monthlyVolStatChartDataSource
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
          },
        },
        series: [{
          type: 'bar',
          // symbol: 'rect',
          // symbolRepeat: true,
          // symbolMargin: '5%',
          // symbolClip: true,
          // symbolSize: ['100%', '100%'],
          label: {
            show: true,
            position: 'top',
            distence: 5
          }
        }],
      }
      this.monthlyVolStatChart.setOption({
        ...defaultChartOption,
        title: {
          text: '本年销量',
          textAlign: 'left'
        },
        yAxis: {
          min: 0,
          max: 800
        },
        dataset: {
          source: this.monthlyVolStatChartDataSource
        }
      }, {
        notMerge: true,
      });

      this.monthlyReceiveStatChart.setOption({
        ...defaultChartOption,
        title: {
          text: '本年回款',
          textAlign: 'left'
        },
        yAxis: {
          min: 0,
          max: 200
        },
        dataset: {
          source: this.monthlyReceiveStatChartDataSource
        }
      }, {
        notMerge: true,
      });
    },
  },
  async created() {
    this.unsubscribeVuexAction = this.$store.subscribeAction({
      after: async (action, state) => {
        if (action.type === 'customerAnalyze/selectCustomerAction') {
          // 将加载数据的内容都写在这里
          this.reloadChart()

          // 载入成本核算
          try {
            this.calcCostTableLoading = true;
            await this.getSalesLatestCost({ customer: this.selectedCustomer._id });
            this.calcCostTableLoading = false;
          } catch (error) {
            this.$Message.error(`加载失败：${error}`);
            this.calcCostTableLoading = false;
          }
        }
      }
    })
    
    
  },
  async mounted() {
    this.drawChart()

    
  },
  destroyed() {
    this.unsubscribeVuexAction()
  },
};
</script>

<style scoped lang="stylus">
.customer-panel
  width 100%
  height calc(100% - 52px)
  overflow-y auto
  padding 12px 12px 48px 12px

.calc-cost-table-wrapper
  max-width 1300px
  padding 8px

.flex
  display flex
</style>
